module.exports = __webpack_public_path__ + "img/privat.4c804fd1.png";